import { QUESTIONNAIRE } from './types';

const initialState = {
    conditionsMet: null,
    responses: [],
    result: '',
    submitted: false
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case QUESTIONNAIRE.SAVE_RESPONSES:
            return {
                ...state,
                responses: action.data.responses
            };
        case QUESTIONNAIRE.SAVE_RESULT:
            return {
                ...state,
                result: action.data.result
            };
        case QUESTIONNAIRE.SUBMIT:
            return {
                ...state,
                submitted: true
            };
        case QUESTIONNAIRE.SET_CONDITIONS_MET:
            return {
                ...state,
                conditionsMet: action.data.conditionsMet
            };
        case QUESTIONNAIRE.RESET:
            return initialState;
        default:
            return state;
    }
};

export default reducer;
